import { Search } from '@components/shared/search/Search';
import { SelectableItem } from '@features/campaign-list/domain/filter';
import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useState } from 'react';

type SearchableListProps = {
  items: SelectableItem[];
  placeholder: string;
  checkedItems: SelectableItem[];
  onListToggle: (value: SelectableItem) => void;
  noDataMessage: string;
};

export const SearchableList = (props: SearchableListProps) => {
  const [searchText, setSearchText] = useState('');

  const filteredItems = props.items.filter(item => {
    return item.name.toLowerCase().includes(searchText.toLowerCase());
  });

  return (
    <>
      <Search
        value={searchText}
        onChange={v => setSearchText(v.target.value)}
        textFieldProps={{
          placeholder: props.placeholder,
          fullWidth: true,
          sx: { backgroundColor: 'white' },
        }}
      />
      {props.items.length > 0 ? (
        <List sx={{ maxHeight: '12rem', overflow: 'scroll' }}>
          {filteredItems.map(item => {
            return (
              <ListItem
                key={item.id}
                disablePadding
                onClick={() => props.onListToggle(item)}
              >
                <ListItemButton dense>
                  <ListItemIcon sx={{ minWidth: 0 }}>
                    <Checkbox
                      edge="start"
                      checked={props.checkedItems.includes(item)}
                    />
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      ) : (
        <Typography sx={{ marginTop: '0.5rem' }}>
          {props.noDataMessage}
        </Typography>
      )}
    </>
  );
};
